import { theme } from '@branchjs/neo-components';
import { css } from 'emotion';

const chip = css`
  background-color: ${theme.colors.primary.contrastWhite};
  border-color: ${theme.colors.gray[200]};
  color: ${theme.colors.gray[500]};
  margin-right: ${theme.spacing(1)};

  &.active {
    color: ${theme.colors.primary.contrastWhite};
    background-color: ${theme.colors.primary.main};
    border-color: ${theme.colors.primary.main};
  }
`;

const chipsContainer = css`
  background: #f7f9fc;
  padding-bottom: ${theme.spacing(3)};
`;

export const chipSelectionStyles = {
  chip,
  chipsContainer,
};
